module.exports = __webpack_public_path__ + "static/media/IMG_20190827_143110.1f9f472a.webp";